<header-bar pageTitle="Categories" headingClass="fa-list"></header-bar>
<router-outlet></router-outlet>